export const GET_COMPLAINTS_FOR_ORGANIZATIONS = "NilonLevel/GetComplaintsForOrganizations";
export const GET_COMPLAINTS_DETAILS = "Complaints/GetComplaintDetails";
export const GET_LOCAL_AUTHORITIES_DETAILS = "Complaints/GetLocalAuthoritiesDetails";
export const GET_TOP_COMPLAINTS_SUBJECTS = "Subject/GetTopComplaintSubjects";
export const GET_SUBJECT_DETAILS = "Subject/GetSubjectDetails";
export const GET_NILON_LEVELS_DROP_DOWN_LIST = "DropDown/GetNilonLevelsDropDownList";
export const GET_SUBJECTS_DROP_DOWN_LIST = "DropDown/GetSubjectsDropDownList";
export const GET_CITIES_DROP_DOWN_LIST = "DropDown/GetCitiesDropDownList";
export const GET_LOCAL_AUTHORITY_DOWN_LIST = "DropDown/GetLocalAuthorityDropDownList";
export const GET_COMPLAINTS_AMOUNT_DOWN_LIST = "DropDown/GetComplaintsAmountDropDownList";
export const GET_COMPLAINI_ABOUT_AUTHORITIES = "NilonLevel/GetComplaintAboutAuthorities";
export const GET_DISTRIBUTION_OF_COMPLAINTS = "NilonLevel/GetNilonLevelTableDetails";
export const GET_DISTRICTS_FOR_MAP = "Complaints/GetDistricts";
export const GET_DISTRICT_DETAILS = "Complaints/GetDistrictDetails";
export const GET_COMPLAINT_AMOUNT = "Complaints/GetComplaintAmount";
export const GET_COMPLAINTS_BY_GENDER = "Complaints/GetComplaintsByGender";
export const GET_HANDLING_COMPLAINTS = "Complaints/GetHandlingComplaints";
export const GET_CITIES = "Complaints/GetCities";
export const GET_COMPLAINT_SUBJECTS_GENDER_GAP = "Subject/GetComplaintSubjectsGenderGap";
export const GET_COMPLAINTS_BY_HOW_COMPLAINTS_ARE_RECEIVED = "Complaints/GetComplaintsByHowComplaintsAreReceived";
export const GET_COMPLAINT_SUBJECTS_GENDER_GAP_DETAIL = "Subject/GetTopRootSubjectsGenderGapDetail";
export const GET_POPULATION = "Population/GetPopulation";
